import DummyRouter from '@/features/ui/components/DummyRouter.vue'
import { PermissionActions } from '@/features/permissions/permissionActions.js'

export const superAdminPeopleManagementRoutes = [
  {
    path: 'people',
    component: DummyRouter,
    meta: {
      permissionAction: PermissionActions.SuperAdminLimitedPeopleView,
    },
    children: [
      {
        path: '',
        component: () => import('./list/SuperAdminPeopleManagementListView.vue'),
        meta: {
          permissionAction: PermissionActions.SuperAdminLimitedPeopleView,
        },
      },
      {
        path: ':peopleId',
        component: () => import('./view/SuperAdminPeopleManagementEditView.vue'),
        meta: {
          permissionAction: PermissionActions.SuperAdminLimitedPeopleView,
        },
      },
    ],
  },
]
